import { createContext, useState, useEffect } from "react";
import { getInstruments } from '../api/backendApi'; 

export const ChartContext = createContext({
    instrument: {},
    setInstrument: () => { },
    instruments: {},
    setInstruments: () => { },
    granularity: {},
    setGranularity: () => { },
    chartOptions: {},
    setChartOptions: () => { },
    seriesType: "",
    setSeriesType: () => { },
    virtualAssistantSettings: {},
    setVirtualAssistantSettings: () => { }
})

export default function ChartContextProvider({ children }) {
    /* Holds context for the chart - user settings, instrument etc. Used in Series */
    const [instrument, setInstrument] = useState(() =>  JSON.parse(localStorage.getItem("instrument")) ||  {name: "EURUSD", display_name: "EUR/USD", type: "forex", active: true, precision: 5, pip_value: 0.00001 });
    const [granularity, setGranularity] = useState(() => JSON.parse(localStorage.getItem("granularity")) || { label: "1m", value: 60 });
    const [chartOptions, setChartOptions] = useState(() => JSON.parse(localStorage.getItem("chartOptions")) || {});
    const [seriesType, setSeriesType] = useState(() => localStorage.getItem("seriesType") || "candlestick");
    const [virtualAssistantSettings, setVirtualAssistantSettings] = useState(() => JSON.parse(localStorage.getItem("virtualAssistantSettings")) || { on: false, ema: false, channel: false, channelBackground: false, channelBars: 100, channelTimeframe: 3600, channelZone: 30, sensitivity: 1, length: 1, emaPeriod1: 20, emaPeriod2: 50, emaPeriod3: 100, emaPeriod4: 200, emaColor1: "red", emaColor2: "blue", emaColor3: "yellow", emaColor4: "green"  });
    const [chatGPTData, setChatGPTData] = useState(null);
    const [instruments, setInstruments] = useState([]);
    const [isSoundEnabled, setIsSoundEnabled] = useState(false);

    useEffect(() => {
        (async () => {
             const response = await getInstruments();
            if (response.status === 200) {
                const resData = await response.json();
                setInstruments(resData);
            }
        })();
    }, []);

    useEffect(() => {
        localStorage.setItem("instrument",  JSON.stringify(instrument) );
        localStorage.setItem("granularity", JSON.stringify(granularity));
        localStorage.setItem("chartOptions", JSON.stringify(chartOptions));
        localStorage.setItem("seriesType", seriesType);
        localStorage.setItem("virtualAssistantSettings", JSON.stringify(virtualAssistantSettings));
    }, [instrument, granularity, chartOptions, seriesType, virtualAssistantSettings]);

    // Fix error on mobile - "typeof Notification !== "undefined" &&"
    if (typeof Notification !== "undefined" && Notification.permission === "default")
        Notification.requestPermission();

    return (
        <ChartContext.Provider value={{ instrument, setInstrument, instruments, granularity, setGranularity, chartOptions, setChartOptions, seriesType, setSeriesType, virtualAssistantSettings, setVirtualAssistantSettings, chatGPTData, setChatGPTData,  isSoundEnabled,
                setIsSoundEnabled }}>
            {children}
        </ChartContext.Provider>
    )
}